module.exports = __webpack_public_path__ + "static/1-4ec9cf7f682dce7b7967d4066a37bfd9.jpg";